module.exports = __webpack_public_path__ + "static/media/00_insti.5c40099d.jpg";